import { CommonModule } from '@angular/common';
import { Component, TrackByFunction, inject } from '@angular/core';
import { LoaderService } from '../../../services/loader.service';
import { BarrierefreiheitService } from '../../../services/facetten/instance/barrierefreiheit.service';
import { ScreenSizeService, ViewMode } from '../../../services/screen-size';
import { FilterSelectItem } from '../../checkbox-facette/checkbox-liste/filterSelectItem';
import { BasisFacetteComponent } from '../basis-facette/basis-facette.component';

@Component({
  selector: 'now-wbsuche-lib-barrierefreiheit-facette',
  templateUrl: './barrierefreiheit-facette.component.html',
  imports: [BasisFacetteComponent, CommonModule]
})
export class BarrierefreiheitFacetteComponent {
  facettenService = inject(BarrierefreiheitService);
  loaderService = inject(LoaderService);
  screenSizeService = inject(ScreenSizeService);

  public expanded$ = this.facettenService.expanded$;
  public items$ = this.facettenService.getSelectItems$();

  trackById: TrackByFunction<FilterSelectItem> = (_, { key }) => key;

  isNoMobile = this.screenSizeService.rangeFrom$(ViewMode.PHABLET);

  public updateSelectedIds(...selectedIds: string[]): void {
    this.facettenService.updateSelectedIds(selectedIds);
  }
}
